module.exports = __webpack_public_path__ + "static/media/cleopatra.19c9ce53.jpg";